import {t} from "../../../_i18n";

export function isValidNASS(value:any) {
    const nass = value === undefined || value === null ? '' : String(value);
    if (!nass) return t('nass_error_required');
    if (nass.length !== 12) return t('nass_error_length');
    if (!/^[0-9]+$/.test(nass)) return t('nass_error_digits');
    const prefix = parseInt(nass.substring(0, 2), 10);
    if (prefix < 1 || prefix > 53) return t('nass_error_prefix');
    return false;
}
